<template>
    <v-container fluid class="pt-0">
        <HeaderListaPlanejamentoEcomm
            titulo="Vinculo plano x fonecedor"
            :pesquisa.sync="pesquisa"
            @exportar="exportar"
            @importar="abrirImportacao"
            hideCadastrar
        />

        <v-card class="px-5 py-5 br-15 w-100 mt-5" elevation="0">
            <v-data-table
                class="elevation-0 tabela"
                :headers="headers"
                :items="dados"
                :items-per-page="10"
                :footer-props="tableConfig"
                :header-props="{ sortIcon: 'mdi-chevron-down' }"
                :search="pesquisa"
                v-model="selecionado"
                item-key="chave_lote"
                multi-sort
                show-select
            >
                <template v-slot:[`item.ativo`]="{ item }">
                    <v-btn
                        :icon="isAtivo(item.ativo)"
                        :color="isAtivo(item.ativo) ? 'success' : 'error'"
                        @click="toggleAtivacao(item)"
                        :loading="item.carregando"
                        :disabled="item.carregando"
                        size="small"
                        class="mx-1"
                    >
                        <v-icon>{{ isAtivo(item.ativo) ? 'mdi-power' : 'mdi-power-off' }}</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
            <div class="table-footer-prepend">
                <v-btn
                    color="success"
                    class="new-button mt-3 ml-3"
                    v-if="selecionado.length > 0"
                    :loading="carregandoAcaoLote"
                    :disabled="carregandoAcaoLote"
                    dark
                    @click="ativarDesativarSelecionados(true)"
                >
                    Ativar selecionados
                </v-btn>
                <v-btn
                    color="error"
                    class="new-button mt-3 ml-3"
                    v-if="selecionado.length > 0"
                    :loading="carregandoAcaoLote"
                    :disabled="carregandoAcaoLote"
                    dark
                    @click="ativarDesativarSelecionados(false)"
                >
                    Desativar selecionados
                </v-btn>
            </div>
        </v-card>
        <v-overlay :value="carregando" :z-index="300">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-dialog
            content-class="br-15"
            scrollable
            v-model="dialogoExcluir"
            width="600"
        >
            <v-card>
                <v-toolbar
                    elevation="0"
                    dark
                    class="error white--text fix-flex"
                >
                    <v-toolbar-title> Excluir ativações</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        fab
                        width="24px"
                        height="24px"
                        elevation="0"
                        light
                        @click="dialogoExcluir = false"
                    >
                        <v-icon size="20px" color="error">mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="pa-5">
                    Deseja realmente <span style="color: red">excluir</span>
                    {{ listaExclusao.length }}
                    {{ listaExclusao.length === 1 ? 'ativação' : 'ativações' }}?
                    <br />
                    <br />
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        class="new-button mr-3 px-4 mb-4"
                        @click="dialogoExcluir = false"
                    >
                        <v-icon class="mr-3">mdi-close-circle</v-icon>

                        Não, não quero exluir
                    </v-btn>
                    <v-btn
                        class="new-button px-4 mb-4 mr-4"
                        color="primary"
                        @click="confirmarExclusao()"
                    >
                        <v-icon class="mr-3">mdi-check-circle</v-icon>
                        Sim, quero excluir
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog content-class="br-15" v-model="dialogoForm" width="600">
            <v-card>
                <v-toolbar
                    elevation="0"
                    dark
                    class="primary-degrade white--text fix-flex"
                >
                    <v-toolbar-title
                        >{{
                            form.id_ativacao ? 'Editar' : 'Cadastrar'
                        }}
                        Ativação</v-toolbar-title
                    >
                    <v-spacer></v-spacer>
                    <v-btn
                        fab
                        width="24px"
                        height="24px"
                        elevation="0"
                        light
                        @click="dialogoForm = false"
                    >
                        <v-icon size="18px" color="primary">mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="pa-5">
                    <v-form ref="form">
                        <v-alert class="mb-4" v-if="alerta" dark color="error">
                            {{ alertaMensagem }}
                        </v-alert>
                        <v-row class="pt-4">
                            <v-col cols="12" class="my-0 py-0">
                                <v-text-field
                                    label="Nome"
                                    v-model="form.nome"
                                    class="input-cinza"
                                    :rules="regra.nome"
                                    outlined
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" class="my-0 py-0">
                                <v-select
                                    label="Device"
                                    v-model="form.device"
                                    :items="devices"
                                    class="input-cinza"
                                    :rules="regra.device"
                                    :menu-props="menuProps"
                                    outlined
                                    chips
                                    multiple
                                    dense
                                >
                                </v-select>
                            </v-col>
                            <v-col cols="6" class="my-0 py-0">
                                <vuetify-money
                                    label="Custo"
                                    v-model="form.custo"
                                    class="input-cinza"
                                    outlined
                                    dense
                                />
                            </v-col>

                            <v-col class="d-flex justify-end">
                                <v-btn
                                    color="primary"
                                    class="ml-auto new-button"
                                    @click="salvar()"
                                >
                                    <v-icon left>mdi-check-circle</v-icon>
                                    Salvar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-dialog>
        <Importacao
            v-model="dialogoImportacao"
            @filtrar="filtrar"
        />
    </v-container>
</template>

<script>
import HeaderListaPlanejamentoEcomm from '@/views/planejamento_ecommerce/cadastro_plano_pacote/_components/headerListaPlanejamentoEcomm.vue'
import Importacao from './Importacao.vue';
import { buildDeviceArrayFromFlags, getDeviceOptions } from '@/hooks/useDeviceOrder'

export default {
    name: 'plano_fornecedor',
    components: {
        HeaderListaPlanejamentoEcomm,
        Importacao,
    },

    data() {
        return {
            menuProps: {
                bottom: true,
                offsetY: true,
                contentClass: 'select-outline',
                transition: 'slide-y-transition',
            },
            listaCampos: {
                status: [],
            },
            selecionado: [],
            carregando: false,
            carregandoAcaoLote: false,
            pesquisa: '',
            dialogo: false,
            dialogoForm: false,
            dialogoExcluir: false,
            dialogoImportacao: false,
            alertaMesagem: '',
            erroModelo: false,
            listaErro: [],
            dragging: false,
            file: null,
            alerta: false,
            listaExclusao: [],
            alertaMensagem: '',
            form: {
                id_ativacao: null,
                nome: null,
                app: null,
                desktop: null,
                mobile: null,
                custo: null,
                device: [],
            },
            devices: getDeviceOptions(),
            tableConfig: {
                itemsPerPageOptions: [5, 10, 20, 50, 100, -1],
                itemsPerPageText: 'Linhas por páginas',
                ofText: 'de',
                pageText: '{0}-{1} de {2}',
            },
            textFieldProps: {
                outlined: true,
                dense: true,
                class: 'input-cinza',
                'hide-details': true,
            },
            timeProps: {
                useSeconds: false,
                ampmInTitle: true,
                format: '24hr',
            },
            dados: [],
            regra: {
                nome: [(v) => !!v || 'Campo Nome é obrigatório.'],
                device: [(v) => v.length > 0 || 'Campo Device é obrigatório.'],
            },
            headers: [
                {
                    text: 'Ativação',
                    value: 'ativo',
                    class: 'th-separador min-width-100',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'Código RD fornecedor',
                    value: 'id_fornecedor',
                    class: 'th-separador min-width-100',
                    align: 'center',
                },
                {
                    text: 'Fornecedor',
                    value: 'fornecedor',
                    class: 'th-separador min-width-100',
                    align: 'center',
                },

                {
                    text: 'Ano',
                    value: 'ano',
                    class: 'th-separador min-width-100',
                    align: 'center',
                },
                {
                    text: 'ID Plano Pacote',
                    value: 'id_plano_pacote',
                    class: 'th-separador min-width-100',
                    align: 'center',
                },
                {
                    text: 'Plano',
                    value: 'plano',
                    class: 'th-separador min-width-100',
                    align: 'center',
                },
                // Categoria
                {
                    text: 'Pacote',
                    value: 'pacote',
                    class: 'th-separador min-width-100',
                    align: 'center',
                }
            ],
        }
    },

    created() {
        this.filtrar()
    },
    computed: {
        extension() {
            return this.file
                ? this.file.name.split('.').pop().toLowerCase()
                : ''
        },
    },
    methods: {
        novo() {
            this.resetarForm()
            this.dialogoForm = true
        },
        editar(item) {
            this.form.id_ativacao = item.id_ativacao
            this.form.nome = item.nome
            this.form.device = buildDeviceArrayFromFlags(item)
            this.form.custo = item.custo
            this.dialogoForm = true
        },
        async salvar() {
            this.$refs.form.validate()
            const data = {
                id_ativacao: this.form.id_ativacao,
                nome: this.form.nome,
                app: this.form.device.includes('app') ? true : false,
                desktop: this.form.device.includes('desktop') ? true : false,
                mobile: this.form.device.includes('mobile') ? true : false,
                custo: this.form.custo,
            }

            const response = await this.$http().post(
                '/planejamentoEcommerce/ativacao/salvar',
                data
            )

            if (response.status == 200) {
                this.$dialog.notify.success('Ativação salva com sucesso!')
                this.dialogoForm = false
                this.filtrar()
            } else {
                this.$dialog.notify.error(
                    response.data.mensagem || 'Erro ao salvar Ativação!'
                )
            }
        },
        excluir(itens) {
            this.listaExclusao = itens
            this.dialogoExcluir = true
        },
        async confirmarExclusao() {
            const data = {
                id_ativacao: this.listaExclusao.map((item) => item.id_ativacao),
            }

      const response = await this.$http().post(
        "/planejamentoEcommerce/fornecedor-pacote/salvar",
        data
      );

            if (response.status == 200) {
                this.$dialog.notify.success('Ativação excluída com sucesso!')
                this.dialogoExcluir = false
                this.selecionado = []
                this.listaExclusao = []

                this.filtrar()
            } else {
                this.$dialog.notify.error(
                    response.data.mensagem || 'Erro ao excluir Ativação!'
                )
            }
        },

        resetarForm() {
            try {
                this.$refs.form.resetValidation()
            } catch (error) {
                console.log(error)
            }

            this.form = {
                id_ativacao: null,
                nome: null,
                app: null,
                desktop: null,
                device: [],
                mobile: null,
                custo: null,
            }
        },
        async exportar() {
            const data = {}
            const response = await this.$http().post(
                '/planejamentoEcommerce/fornecedor-pacote/exportar',
                data
            )

            if (response.status == 200) {
                this.$dialog.notify.success('Vinculo fornecedor exportada com sucesso!')
                window.location = this.$http('baseURL') + response.data.url
            } else {
                this.$dialog.notify.error(
                    response.data.mensagem || 'Erro ao exportar Vinculo fornecedor!'
                )
            }
        },
        onChange(e) {
            var files = e.target.files || e.dataTransfer.files

            if (!files.length) {
                this.dragging = false
                return
            }

            this.createFile(files[0])
        },
        createFile(file) {
            this.file = file
            if (this.extension !== 'csv') {
                console.log(file)
                this.alerta = true
                this.alertaMesagem = 'O arquivo deve ser do tipo CSV.'
                this.dragging = false
                this.file = ''
                return
            }

            console.log(this.file)
            this.dragging = false
        },
        removeFile() {
            this.file = ''
        },
        abrirImportacao() {
            this.dialogoImportacao = true
            this.file = ''
        },
        async filtrar() {
            this.carregando = true
            const data = {}
            const response = await this.$http().post(
                '/planejamentoEcommerce/fornecedor-pacote/lista',
                data
            )

            if (response.data.data && response.data.data.length > 0) {
                this.dados = response.data.data.map(item => ({
                    ...item,
                    chave_lote: `${item.id_fornecedor}-${item.id_plano_pacote}-${item.ano}`,
                    carregando: false,
                    ativo: this.normalizarAtivo(item.ativo)
                }))
            } else {
                this.dados = []
            }
            this.selecionado = []
            this.carregando = false
        },
        async toggleAtivacao(item) {
            // Marcar como carregando
            this.$set(item, 'carregando', true)
            
            try {
                const data = {
                    id_fornecedor: item.id_fornecedor,
                    id_plano_pacote: item.id_plano_pacote,
                    ano: item.ano
                }

                const response = await this.$http().post(
                    '/planejamentoEcommerce/fornecedor-pacote/ativarDesativar',
                    data
                )

                if (response.status === 200 && response.data.sucesso === 1) {
                    // Sucesso - atualizar o estado
                    this.$set(item, 'ativo', this.normalizarAtivo(response.data.ativo))
                    
                    const mensagem = this.normalizarAtivo(response.data.ativo)
                        ? 'Plano/Fornecedor ativado com sucesso!' 
                        : 'Plano/Fornecedor desativado com sucesso!'
                    this.$dialog.notify.success(mensagem)
                } else if (response.status === 200 && response.data.sucesso === 0) {
                    // Validação falhou - exibir mensagem de erro
                    this.$dialog.notify.warning(response.data.msg || 'Não foi possível desativar. Verifique se existem planejamentos ativos.')
                } else {
                    this.$dialog.notify.error('Erro ao processar a ativação')
                }
            } catch (error) {
                console.error('Erro ao alternar ativação:', error)
                let mensagemErro = 'Erro ao processar a ativação'
                
                if (error.response?.data?.msg) {
                    mensagemErro = error.response.data.msg
                } else if (error.response?.data?.mensagem) {
                    mensagemErro = error.response.data.mensagem
                }
                
                this.$dialog.notify.error(mensagemErro)
            } finally {
                this.$set(item, 'carregando', false)
            }
        },
        async ativarDesativarSelecionados(ativo) {
            if (!this.selecionado.length) {
                this.$dialog.notify.warning('Selecione ao menos um registro.')
                return
            }

            this.carregandoAcaoLote = true

            try {
                const registros = this.selecionado.map((item) => ({
                    id_fornecedor: item.id_fornecedor,
                    id_plano_pacote: item.id_plano_pacote,
                    ano: item.ano,
                }))

                const response = await this.$http().post(
                    '/planejamentoEcommerce/fornecedor-pacote/ativarDesativarVarios',
                    {
                        registros,
                        ativo,
                    }
                )

                if (response.status === 200) {
                    const { processados, total, msg, erros } = response.data || {}
                    const mensagemPadrao =
                        processados === total
                            ? `Registros ${ativo ? 'ativados' : 'desativados'} com sucesso!`
                            : `${processados || 0} de ${total || registros.length} registro(s) processado(s) com sucesso.`

                    if (processados === total) {
                        this.$dialog.notify.success(msg || mensagemPadrao)
                    } else {
                        this.$dialog.notify.warning(msg || mensagemPadrao)
                    }

                    if (Array.isArray(erros) && erros.length) {
                        const primeiraMensagemErro = erros[0]?.msg
                        if (primeiraMensagemErro) {
                            this.$dialog.notify.warning(primeiraMensagemErro)
                        }
                    }

                    this.selecionado = []
                    await this.filtrar()
                } else {
                    this.$dialog.notify.error('Erro ao processar ativação em lote.')
                }
            } catch (error) {
                console.error('Erro ao ativar/desativar em lote:', error)
                let mensagemErro = 'Erro ao processar ativação em lote.'

                if (error.response?.data?.msg) {
                    mensagemErro = error.response.data.msg
                } else if (error.response?.data?.mensagem) {
                    mensagemErro = error.response.data.mensagem
                }

                this.$dialog.notify.error(mensagemErro)
            } finally {
                this.carregandoAcaoLote = false
            }
        },
        normalizarAtivo(valor) {
            if (typeof valor === 'boolean') {
                return valor
            }

            if (typeof valor === 'number') {
                return valor === 1
            }

            if (typeof valor === 'string') {
                const normalizado = valor.trim().toLowerCase()

                return ['1', 'true', 'v', '[v]', 'sim', 's', 'yes', 'y', 'ativo'].includes(
                    normalizado
                )
            }

            return false
        },
        isAtivo(valor) {
            return this.normalizarAtivo(valor)
        }
    },
}
</script>
